<style lang="scss">
@import "../../../../common/styles/var.scss";

.fullpage {
  background-image: url("../../assets/bg_login_tj.png");
  background-size: 100% 100%;

  .wrap {
    background-size: 100% 100%;
    background-image: url("../../assets/bg_login_tj_wrap.png");
    margin: 0 auto;
  }
}
</style>
<template>
  <div class="fullpage flex aic jcc column">
    <div class="wrap flex" :style="wrapStyle">
      <div class="logo flex0" :style="logoStyle"></div>
      <div class="ms-login flex0 pt30 pb50 pl30 pr50" :style="logoStyle">
        <h3 class="">登录</h3>
        <p class="mt10 mb30">健康管理平台</p>
        <el-form :model="form" :rules="rules" ref="form" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="userMobile">
            <el-input
                v-model="form.userMobile"
                prefix-icon="el-icon-phone-outline"
                placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userPassword">
            <el-input
                type="password"
                prefix-icon="el-icon-edit-outline"
                placeholder="请输入密码"
                v-model="form.userPassword"
            ></el-input>
          </el-form-item>
          <!--          <el-form-item prop="captcha">
                      <el-input
                          prefix-icon="el-icon-edit-outline"
                          placeholder="请选择机构" disabled v-model="form.captcha">
                      </el-input>
                    </el-form-item>-->
          <div class="login-btn">
            <el-button
                :loading="appShowLoading"
                class="width100"
                type="primary"
                @click="sub"
            >登录
            </el-button>
          </div>
          <div class="flex aic jcc pt10">
            <a href="/">浙二互联网医院官网</a>
          </div>
        </el-form>
      </div>
    </div>
    <login-footer></login-footer>
    <choose-team-dialog ref="teamChoose" @submit="choosed"></choose-team-dialog>
    <!--<div class="footer">Copyright © 2007-2016 | 杭州特扬网络科技有限公司 版权所有</div>-->
  </div>
</template>

<script>
import {staffService} from "../../../staff/service/staff";
import {tokenCache} from "../../../../common/lib/cache/Token";
import {loginInfoCache} from "../../../../common/lib/cache/LoginInfo";
import LoginFooter from "../../components/login-footer";
import {teamListCache} from "@/common/lib/cache/TeamList";
import ChooseTeamDialog from "@/modules/account/components/choose-team-dialog";
import {loginTeamCache} from "@/common/lib/cache/LoginTeam";

export default {
  name: "tj-login",
  components: {ChooseTeamDialog, LoginFooter},
  data() {
    return {
      form: {},
      H: 0,
      navs: [
        {
          name: "浙二互联网医院官网",
          link: "https://www.gjwlyy.com"
        },
        {
          name: "浙大二院官网",
          link: "http://www.z2hospital.com/cms/default.aspx"
        },
        {
          name: "浙二互联网医院官微",
          showQR: false,
          qr: require("../../assets/QR_wechat.png")
        }
      ],
      clients: [
        {
          name: "浙二好医生",
          icon: require("../../assets/pat.png"),
          qr: require("../../assets/QR_pat.png"),
          showQR: false
        },
        {
          name: "浙二好医生医护版",
          icon: require("../../assets/doc.png"),
          qr: require("../../assets/QR_doc.png"),
          showQR: false
        },
        {name: "急救Pad端", icon: require("../../assets/pad.png"), download: true, key: 'apk'},
        {name: "视频客户端", icon: require("../../assets/exe.png"), download: true, key: 'hushi_exe_download'}
      ],
      rules: {
        userMobile: [
          {required: true, message: "请输入手机号", trigger: "blur"}
        ],
        userPassword: [
          {required: true, message: "请输入密码", trigger: "blur"}
        ]
        //captcha: [{required: true, message: "请输入验证码", trigger: "blur"}]
      }
    }
  },
  computed: {
    wrapStyle() {
      const delta = 600 / 960;
      const {H} = this;
      return {
        width: `${H * delta}px`,
        height: `${H * delta / 2}px`
      }
    },
    logoStyle() {
      const delta = 300 / 960;
      const {H} = this;
      return {
        width: `${H * delta}px`,
        height: `${H * delta}px`
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    choosed(team) {
      loginTeamCache.set(team);
      this.$router.push(this.$route.query.callback || '/tj/rili');
    },
    init() {
      this.H = window.innerWidth;
    },
    sub() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let form = {...this.form};
          form.userType = "HEAL_T_ADM";
          // eslint-disable-next-line no-undef
          form.userPassword = sha512(hex_md5(form.userPassword) + form.userPassword)
          const {token, obj} = await staffService.login(form);
          if (token) {
            tokenCache.set(token);
            loginInfoCache.set(obj);
            let teamList = obj.teamList || [];
            teamListCache.set(teamList);
            this.teamList = teamList;
            //bus.$emit(EVENT_LOGIN_SUCCESS, 1);
            if (teamList.length) {
              await this.$refs.teamChoose.open(teamList);
            } else {
              this.$message.error('您还未设置登录团队，请联系管理员设置');
            }
          }
        }
      })
    }
  },
}
</script>

